import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import LanguageToggle from "../Layout/Header/LanguageToggle/LanguageToggle";
import { useAuth } from "../../contexts/AuthContext";

export default function AdminHeader() {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header>
            <div className="header-wrapper w-full fixed left-0 top-0 z-20 bg-[#0A0118] xl:block hidden">
                <div className="w-full relative z-20 mx-auto">
                    <div className="w-full h-[80px] flex justify-between items-center px-6">
                        <div className="flex items-center">
                            <div>
                                <Link to="/admin">
                                    <img src="/assets/images/logo.svg" alt="logo" />
                                </Link>
                            </div>
                        </div>

                        <div className="flex space-x-[30px] items-center">
                            {/* <LanguageToggle /> */}
                            {/* Commented out language toggle for admin to keep it clean */}

                            <button
                                onClick={handleLogout}
                                className="text-gray-400 hover:text-white transition-colors text-sm font-medium flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                Logout
                            </button>

                            <Link to="/">
                                <div className="home-two-btn-bg py-2.5 px-6 group bg-purple border-purple rounded">
                                    <span className="relative z-10 text-base font-semibold text-white transition-all duration-300 group-hover:text-purple font-inter flex items-center gap-2">
                                        Visit Site
                                        <svg
                                            className="relative z-10 w-4 h-4 ml-1"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                            />
                                        </svg>
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="header-four-border w-full h-[1px] bg-white/10"></div>
            </div>
        </header>
    );
}
